import {
  lowerCaseFirstLetter,
  getCurrentTenant
} from '@/utils'

const subscribers = require('./subscribers')
const WebSocketClient = require('websocket').w3cwebsocket
let userInfo = JSON.parse(localStorage.getItem("userInfo"))

let socket = null
let ping = null

export const connect = function() {
  userInfo = JSON.parse(localStorage.getItem("userInfo"))

  if (socket !== null) {
    return;
  }

  socket = new WebSocketClient(
    process.env.VUE_APP_WEBSOCKET_WSS
    + process.env.VUE_APP_WEBSOCKET_ENVIRONMENT
    + '?tenantName=' + getCurrentTenant()
    + '&userId=' + userInfo.id
  )

  socket.onopen = function(ws, req) {
    // console.log('socket connected', event)

    const data = {
      event: 'ping',
      tenantName: getCurrentTenant(),
      userId: userInfo.id
    };

    const dataEncoded = (btoa(JSON.stringify(data)));

    function pingPong(countRetry = 0) {
      try{
        socket.send(`{
          "action": "sendmessage",
          "data": "${dataEncoded}"
        }`)
      } catch (error){
        console.error(error);

        if ( socket === null ){
          return connect();
        } else if ( countRetry > 19 ){
          setTimeout(function() { connect(); }, 1600)
          disconnect();
          return;
        }

        setTimeout(async () => {
          if ( countRetry > 19 ) return;

          countRetry++;
          console.info('Socket | Tentativa de reconexão: ', countRetry)

          pingPong(countRetry);
        }, 300);
      }
    }

    ping = setInterval(pingPong, 29000);
    pingPong()
  }

  socket.onmessage = function(event) {
    // console.log('socket new message')
    const data = JSON.parse(atob(event.data))
    // console.log(data)

    const eventName = lowerCaseFirstLetter(data.event).replace('/', '_')
    subscribers[eventName](data)
  }

  socket.onerror = function(event) {
    console.error('socket new error', event)
  }

  socket.onclose = function() {
    // console.log('socket closed', event)
    socket = null
    ping = null
    setTimeout(function() {
      connect()
    }, 1000)
  }

  window.socket = socket

  window.onbeforeunload = function() {
    disconnect()
  }
}

export const disconnect = function () {
  socket.onclose = function () {}
  socket.close()
  socket = null
  clearInterval(ping);
  ping = null

  // console.log('Socket logout')
}

export default socket
